import { AppBar, Backdrop, Box, Button, Divider, FormControlLabel, FormGroup, Grid, Grow, Paper, Radio, styled, TextField, Tooltip, tooltipClasses, Typography, useMediaQuery, Zoom } from '@mui/material';
import { Container } from '@mui/system';
import React, { useLayoutEffect, useState } from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useHistory, useNavigate, useParams } from 'react-router-dom';
import { getPosts, searchPosts } from '../../actions/posts';
import ChipInput from '../ChipInput/ChipInput';
import Form from '../Form/Form';
import Paginate from '../Pagination/Pagination';
import Posts from '../Posts/Posts';
import styles from './styles';
import { FiX, FiGrid, FiImage, FiHash, FiBookmark, FiHeart  } from "react-icons/fi";
import { HiCode } from "react-icons/hi";
import theme from '../../muiTheme';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import { useWindowScrollPositions } from '../../hooks/useWindowScrollPositions';
import { useRef } from 'react';
import LandingPage from '../LandingPage/LandingPage';
import { getSuggestedUsers } from '../../actions/profile';
import SuggestedAccounts from '../SuggestedAccounts/SuggestedAccounts';
import CustomSwitch from '../Form/CustomSwitch';

const useQuery = () => {

    let location = useLocation();

    return new URLSearchParams(location.search);
}

const Home = ({showForm, setShowForm}) => {

    const [currentId, setCurrentId] = useState(null);
    const [search, setSearch] = useState('');
    const [tags, setTags] = useState([]);
    const dispatch = useDispatch();
    const query = useQuery(); //returns query from url
    const navigate = useNavigate(); 
    const page = query.get('page') || 1;  
    const searchQuery = query.get('searchQuery');
    const tagsQuery = query.get('tags');
    const profile = JSON.parse(localStorage.getItem('profile'));
    const {numberOfPages, posts, searchResults, isLoading, isLoadingSearch} = useSelector((state) => state.posts);
    const {suggestedUsers} = useSelector((state)=>state.profileReducer);
    const [currentPage, setCurrentPage] = useState(1);
    const containerRef = useRef(null); 
    const topDivRef = useRef(null); 
    const [mediaPost, setMediaPost] = useState(false); 

    const isSearch = (searchQuery && searchQuery !== 'none') || (tagsQuery && tagsQuery?.length > 0); 

    useEffect(()=>{
        //for when page is accessed from link with search params
        //get the posts using the url params
        if(isSearch){
            console.log('page accessed from url params!!, searhQuery: ', searchQuery, ' tagsQuery: ', tagsQuery);

            var query = {
                search: searchQuery,
                tags: tagsQuery
            };

            dispatch(searchPosts(query));
        }else{
            dispatch(getPosts(1,false));
        }


        dispatch(getSuggestedUsers(profile ? profile?.result._id : null));

        console.log('profile: ', profile);

    }, []);

    const fetchMorePosts = () => {

        if ((window.innerHeight + window.scrollY) >= containerRef?.current.offsetHeight && !isLoading) {

            //fetch more posts
            if(currentPage+1 <= numberOfPages && !searchQuery && !tagsQuery){

                dispatch(getPosts(currentPage+1, true));
                setCurrentPage(prevValue=>prevValue+1);
                console.log('setting current page state');
            }
    
        }
        
    }

    useEffect(()=>{
        //more performant way of checking user has scrolled to bottom of page:
        window.addEventListener('scroll', fetchMorePosts);


        return () => {

            window.removeEventListener('scroll', fetchMorePosts);
        }

    }, [isLoading]);

    const handleSearchChange = (event) => {

        setSearch(event.target.value);
    }

    const handleKeyUp = (event) => {

        if(event.keyCode === 13){
            
            homeSearchPosts();

        }
    }

    const handleAdd = (tag) => {
        setTags((prevTags)=>[...prevTags, tag]);
    }

    const handleDelete = (tagToDelete) => {

        setTags(tags.filter((tag)=> tag!==tagToDelete));
    }

    const homeSearchPosts = (event) => { 

        console.log('search posts invoked, event: ', event);

        if(search.trim() || tags.length > 0){

            var query = {
                search,
                tags: tags.join(',')
            };

            dispatch(searchPosts(query));
            navigate(`/posts/search?searchQuery=${search || 'none'}&tags=${tags.join(',')}`);
        }else {

            navigate('/');
        }
    }

    const handleOverlayClick = (event) => {

        let className = event.target.getAttribute('class') || ''; 
        if(className.includes('popup-overlay')){
            setShowForm(false); 
        }
    }

    const toggleForm = (event, show = null) => {

        event.preventDefault(); 
        event.stopPropagation(); 

        setShowForm((prevValue)=>show ? show : !prevValue);    
    }


    const openQueryTag = (tag) => {
        var query = {
            search:'none',
            tags: tag
        };

        dispatch(searchPosts(query));

        navigate(`/posts/search?searchQuery=none&tags=${tag}`); 
    }

    const StyledTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} arrow classes={{ popper: className }} />
      ))(({ theme }) => ({
        [`& .${tooltipClasses.arrow}`]: {
          color: theme.palette.primary.main,
        },
        [`& .${tooltipClasses.tooltip}`]: {
          backgroundColor: theme.palette.primary.main,
        },
      }));

    return (

        <>
        
            <Box>
                {
                    !isSearch &&

                    <LandingPage sx={{position: 'fixed', top: '0px'}} anchor={topDivRef}/>
                }
                
            </Box>
            

            <Box sx={{minHeight: '100vh !important'}}>

                

                <Box 
                    className='home-container' 
                    ref={topDivRef} 
                    sx={{
                        ...styles.homeContainer,
                        top: isSearch ? '50px': '100vh', 
                    }}>

                    <Grow in>
                        <Container ref={containerRef} sx={styles.rootContainer} elevation={0}>

                            

                            <Box
                                display={{ xs: 'flex' }} 
                                flexDirection={{xs: 'column'}}
                                justifyContent={{xs: 'center'}}
                                alignItems={{xs: 'center'}}
                                width={{xs: '97%', md: '100%'}}
                                sx={{margin: '40px 0px 0px 5px'}}
                            >

                                {
                                    isSearch ? 

                                    <>
                                    
                                        <Typography variant='h4'>
                                            Your Search Results
                                        </Typography>

                                        <Box
                                            display={{ xs: 'flex' }} 
                                            flexDirection={{xs: 'column'}}
                                            justifyContent={{xs: 'center'}}
                                            alignItems={{xs: 'center'}}
                                            width={{xs: '100%'}}
                                            sx={{marginTop: '20px', flexWrap: 'wrap'}}
                                        >
                                            <Typography variant="body1" sx={{margin: '20px 0px 0px 15px'}}>
                                                {searchQuery && searchQuery !== 'none' ? 'Search Query: "' + searchQuery + '"' : ''}
                                            </Typography>


                                            {tagsQuery?.length > 0 &&

                                                <>

                                                    <Typography variant="body1" sx={{margin: '3px'}}>
                                                            {tagsQuery?.length > 0 ? ' Tags ' : ''}
                                                    </Typography>

                                                    <Box
                                                        display={{ xs: 'flex' }} 
                                                        flexDirection={{xs: 'row'}}
                                                        justifyContent={{xs: 'center'}}
                                                        alignItems={{xs: 'center'}}
                                                        width={{xs: '100%'}}
                                                        sx={{flexWrap: 'wrap'}}
                                                    >
                                                        
                                                        {tagsQuery.split(',').map((tag, index)=>(

                                                            <Typography key={'query'+tag+index} variant="body2" sx={styles.queryTag} color="textSecondary" onClick={()=>openQueryTag(tag)}>
                                                                {`#${tag}`}
                                                            </Typography>
                                                        ))}
                                                        


                                                    </Box>
                                                </>
                                            }
                                            
                                        </Box>
                                

                                
                                    </>

                                    :

                                    <Typography variant='h4'>
                                            Latest Posts
                                    </Typography>

                                }

                                <Divider sx={{width: '80%', margin: '20px 0px'}}/>
                                
                            </Box>
                                
                            
                            
                            <Grid 
                                sx={styles.gridContainer} 
                                variant="responsive" 
                                container justify="space-between" 
                                alignItems="stretch" 
                                spacing={1} >
                
                                <Grid item xs={12} sm={12} md={12} lg={8}>

                                    <Box
                                        display={{xs: 'block', md: 'flex'}}
                                        alignItems='start'
                                        flexDirection={{md: 'row'}}
                                        justifyContent={{md: 'center'}}
                                        width={{md: '100%'}}
                                    >



                                        <Box item 
                                            display={{ xs: 'none', md: 'flex' }} 
                                            flexDirection={{md: 'column'}}
                                            justifyContent={{md: 'center'}}
                                            alignItems={{md: 'center'}}
                                            width={{md: '100px'}}
                                            height={{md: 'auto'}}
                                            position={{md: 'sticky'}}
                                            top={{md: '100px'}}
                                            sm={1} 
                                            sx={styles.sideMenu}
                                        >



                                            {
                                                profile && 

                                                <>

                                                    <StyledTooltip 
                                                        
                                                        title='New Post' 
                                                        arrow 
                                                        
                                                        onClick={toggleForm}
                                                        TransitionComponent={Zoom}
                                                        enterDelay={50}
                                                        placement="left"
                                                        >
                                                        <Box sx={styles.sideMenuItem} className='new-post-button' >
                                                            <FiImage style={styles.sideMenuIcon}/>
                                                        </Box>
                                                    </StyledTooltip>
                                                    

                                                    <StyledTooltip 
                                                        
                                                        title='Coming Soon!' 
                                                        arrow 
                                                        TransitionComponent={Zoom}
                                                        enterDelay={50}
                                                        placement="left"
                                                        >

                                                        <Box sx={styles.sideMenuItem}>
                                                            <FiHeart style={styles.sideMenuIcon}/>
                                                        </Box>
                                                    </StyledTooltip>
                                                    

                                                    <StyledTooltip 
                                                        
                                                        title='Coming Soon!' 
                                                        arrow 
                                                        
                                                        TransitionComponent={Zoom}
                                                        enterDelay={50}
                                                        placement="left"
                                                        >

                                                        <Box sx={styles.sideMenuItem}>
                                                            <FiBookmark style={styles.sideMenuIcon}/>
                                                        </Box>
                                                    </StyledTooltip>

                                                </>
                                            }
                                            

                                            {/* Takes user to page containing top 20 posts with most likes*/}
                                            <StyledTooltip 
                                                        
                                                title='Coming Soon!' 
                                                arrow 
                                                TransitionComponent={Zoom}
                                                enterDelay={50}
                                                placement="left"
                                                >

                                                <Box sx={styles.sideMenuItem}>
                                                    <FiGrid style={styles.sideMenuIcon}/>
                                                </Box>
                                            </StyledTooltip>
                                            
                                            {/*Takes user to page showing popular hashtags */}
                                            <StyledTooltip 
                                                        
                                                title='Coming Soon!' 
                                                arrow 
                                                TransitionComponent={Zoom}
                                                enterDelay={50}
                                                placement="left"
                                                >

                                                <Box sx={styles.sideMenuItem}>
                                                    <FiHash style={styles.sideMenuIcon}/>
                                                </Box>
                                            </StyledTooltip>
                                            
                                            
                                            
                                        </Box>

                                        <Box
                                            className='postbox'
                                            width={{md: '80%'}}
                                            background={{xs: theme.palette.background.card, md: theme.palette.background.container}}
                                        >

                                            <Posts 
                                                currentId={currentId} 
                                                posts={isSearch ? searchResults : posts} 
                                                isLoading={isSearch ? isLoadingSearch : isLoading} 
                                                setCurrentId={setCurrentId}/>
                                            
                                            {/* {(!searchQuery && !tags?.length>0 && !tagsQuery?.length>0) && (
                                                <Paper sx={styles.paginationContainer} elevation={0}>
                                                        <Paginate page={page} />
                                                </Paper>
                                            )}  */}
                                        </Box>
                                    </Box>
                                    
                                </Grid>


                                <Grid item xs={12} sm={12} md={3}>

                                    {/* This will now show who to follow - new users and most followed users */}

                                    <Box
                                        display={{ xs: 'none', md: 'flex' }} 
                                        position={{xs: 'relative', md: 'sticky'}}
                                        top={{xs: 'auto', md: '120px'}}
                                        sx={{
                                           flexDirection: 'column',
                                           padding: '0px'
                                           //width: '200px'
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                borderRadius: '40px',
                                                //background: '#28a745c9',
                                                padding: '0px',
                                                width: 'auto',
                                                //textAlign: 'center',
                                                marginBottom: '10px'
                                            }}
                                        >
                                            <Typography variant='logo' sx={{color: theme.palette.gray}}>
                                                QuickShot
                                            </Typography>
                                        </Box>

                                        <Box
                                            sx={{
                                                borderRadius: '40px',
                                                background: '#28a745c9',
                                                padding: '5px 15px',
                                                width: '40%',
                                                textAlign: 'center',
                                                color: 'white',
                                                display: 'flex',
                                                flexDirection: 'row',
                                                alignItems: 'center',
                                                justifyContent: 'flex-start'
                                            }}
                                        >
                                            <HiCode style={{marginRight: '5px'}}/>
                                            <Typography variant='body2' sx={{fontStyle: 'normal'}}>
                                                version 0.1.0
                                            </Typography>
                                        </Box>

                                        <Box
                                            sx={{
                                                
                                                marginTop: '20px'
                                            }}
                                        >
                                            <Typography variant='body2' sx={{color: theme.palette.gray}} >
                                                Please note that this product is still in its early stages of development.
                                            </Typography>
                                        </Box>

                                        <Divider sx={{margin: '20px 0px'}}/>

                                        <Box
                                            sx={{
                                                
                                                marginTop: '0px'
                                            }}
                                        >
                                            <Typography variant='h6' sx={{color: theme.palette.gray, marginBottom: '5px'}} >
                                                {profile ? 'Suggested Users' : 'Latest Users'}
                                            </Typography>

                                            <SuggestedAccounts 
                                            
                                                containerSx={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    flexWrap: 'wrap',
                                                    alignItems: 'flex-start',
                                                    justifyContent: 'flex-start'
                                                }}      
                                                profileSx={{
                                                    margin: '0px 0px',
                                                    //background: theme.palette.faint,
                                                    borderRadius: '10px',
                                                    //padding: '10px 20px',
                                                    width: '100%',
                                                    background: 'transparent',
                                                    padding: '10px 0px', //TODO
                                                }} 

                                                imageSx={{
                                                    width: '60px',
                                                    height: '60px',
                                                    borderWidth: '0px'
                                                }}

                                                nameSx={{
                                                    fontSize: '16px'
                                                }}
                                            />
                                        </Box>
                                        

                                        
                                    </Box>
                                    
                                </Grid>
                            </Grid> 
                            
                        </Container>

                    </Grow>
                </Box>

            
            
                
                
            </Box>

            <Backdrop
                className='popup-overlay'
                open={showForm}
                sx={styles.popUpOverlay}
                onClick={handleOverlayClick}
            >

                {
                    showForm &&


                    <Grow in>

                        
                            <Box 
                                width={{xs: '100vw', md: 'auto'}}
                                height={{xs: '100%', md: 'auto'}}
                                padding={{xs: '200px', md: '0px'}}
                                style={styles.formContainer}
                            >

                                <Box
                                    width={{xs: '100%'}}
                                    height={{xs: '20px'}}
                                    padding={{xs:'20px', md: '0px'}}
                                    style={styles.formHeaderBar}
                                >
                                    <Button 
                                        className='form-cancel-button' 
                                        sx={styles.formCancelButton} 
                                        variant='main' 
                                        onClick={(e)=>{toggleForm(e, false)}}>
                                        <FiX /> 
                                    </Button>
                                </Box>

                                <Typography sx={styles.formTitle} variant='h4'>
                                    {currentId ? 'Edit ': 'Create a new' } {mediaPost ? ' media' : ''} post
                                </Typography>

                                {
                                    (!currentId && profile.result.verified ) &&

                                    <>
                                    
                                        <Typography sx={{color: theme.palette.gray, fontSize: '13px', marginTop: '5px'}} variant='body1'>
                                            They won't know what hit'em!
                                        </Typography>
                                        
                                    </>
                                       
                                    
                                    
                                }

                                {
                                    !profile.result.verified && 

                                    <>

                                        <Typography variant="body1" sx={{textAlign: 'center', fontSize: '13px', padding: '5px 0px', color: theme.palette.warning.main}}>
                                            Please note
                                        </Typography>
                                    
                                        <Typography variant="body1" sx={{textAlign: 'center', fontSize: '13px', padding: '0px', }}>
                                            This account is not yet verified. The forms are active, but your post will not be saved. Please get in touch with the development team to enable your account.
                                        </Typography>

                                    </>
                                }
                                

                                <Divider sx={{width: '70%', marginTop: '20px'}} />
            
                                   
                                <Form 
                                    currentId={currentId} 
                                    setCurrentId={setCurrentId} 
                                    onSubmit={()=>{setShowForm(false)}} 
                                    mediaPost = {mediaPost}
                                    additionalFields = {
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'flex-start',
                                                boxSizing: 'border-box',
                                                width: '100%'
                                            }}
                                        >
                                            <CustomSwitch 
                                                label='Media focused Post'
                                                name='mediaPost'
                                                checked={mediaPost}
                                                onChange={(event)=>{setMediaPost(prevValue => !prevValue)}}
                                            /> 
                                        </Box>
                                    }
                                />

                            </Box>
                    
                    </Grow>
                }
                

            </Backdrop>
        </>
    );
}

export default Home; 